<button [style.background-image]="'url(' + assetsUrl + 'img/botones/Boton_Validar%20Denuncia.png)'"
  class="btn btn-rounded btn-cabecera" matTooltip="{{'texto_112' | translate }}" type="button" mdbBtn rounded="true"
  data-toggle="modal" data-target="#basicExample" (click)="frame.show()" mdbWavesEffect>
</button>

<div mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document" style="max-width: 100% !important;">
    <!--Content-->
    <div class="modal-content">

      <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
        <div class="card-header card-header-info">
          <h5 style="margin-bottom: 0px;" class="card-title">{{ 'texto_112' | translate }}</h5>
        </div>
        <button type="button" style="z-index:100;float: right;margin-top: -2.8rem;" class="btn btn-dark"
          data-dismiss="modal" (click)="frame.hide()" aria-label="Cerrar modal">X</button>

        <div class="row">
          <div class='col-xs-12 col-sm-12'>
            <mat-checkbox id="validarDenuncia" name="validarDenuncia" [formControl]="validarDenuncia">{{ 'texto_113' |
              translate }}</mat-checkbox>
          </div>
        </div>

        <div *ngIf="validarDenuncia.value" class="row mt-3">
          <div class="col-12">
            <div class="form-group">
              <label for="complianceSelect" class="control-label">
                {{ 'texto_863' | translate }}
              </label>

              <!-- Display Random Compliance -->
              <div [hidden]="inicial" class="text-center mt-2">
                <div id="compliance" name="compliance">
                  <ng-container *ngIf="allCompliances.length > 0; else noCompliances">
                    <p>
                      {{ 'texto_864' | translate }} <strong>{{ nameComplianceRandom }}</strong>
                    </p>
                    <div *ngIf="gestionarConflicto == '1' && allCompliances.length > 1" class="mt-2">
                      <p style="font-size: 14px;">
                        *{{ 'texto_865' | translate }}
                      </p>
                      <button style="color:#fff" mdbBtn rounded="true" class="btn-primary mt-1 waves-light"
                        mdbWavesEffect (click)="chooseComplianceBySelect()" (click)="showFirstComplianceDeclined()">
                        {{ 'texto_866' | translate }}
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #noCompliances>
                    <p style="color: red;">
                      {{ 'texto_891' | translate }}
                    </p>
                  </ng-template>
                </div>
              </div>

              <!-- Select Compliance User -->
              <div [hidden]="!inicial" class="text-center mt-2 mb-3">
                <form [formGroup]="validatingForm">
                  <div id="compliance" name="compliance">
                    <mat-form-field style="min-width:300px;">
                      <mat-label>{{ 'texto_140' | translate }}</mat-label>
                      <mat-select formControlName="userCompliance" #complianceSelect id="complianceSelect"
                        (click)="chooseComplianceBySelect()" (selectionChange)="onChangeUserCompliance($event)"
                        required>
                        <mat-option *ngFor="let item of compliances" [value]="item.id_user">
                          {{ item.n_user }} {{ item.ape_user }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="validatingForm.get('userCompliance')?.hasError('required')">
                        {{ 'texto_288' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div>
                    <button style="color:#fff" mdbBtn rounded="true" class="btn-primary mt-1 waves-light" mdbWavesEffect
                      (click)="chooseComplianceRandom()">
                      {{ 'texto_867' | translate }}
                    </button>
                  </div>

                  <!-- Confict interest compliance -->
                  <div *ngIf="allCompliances.length > 2">
                    <p style="font-size: 14px; margin: 16px;">* {{ 'texto_880' | translate }}</p>
                    <mat-form-field style="min-width:300px;">
                      <mat-label>{{ 'texto_140' | translate }}</mat-label>
                      <mat-select multiple formControlName="compliancesToDecline" #compliancesToDeclineSelect
                        id="compliancesToDeclineSelect" (click)="chooseCompliancesDeclinedBySelect()"
                        (selectionChange)="addComplianceDeclined($event)">
                        <mat-option *ngFor="let item of compliancesToDecline" [value]="item.id_user">
                          {{ item.n_user }} {{ item.ape_user }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="validatingForm.get('userCompliance')?.hasError('required')">
                        {{ 'texto_288' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>

        <div class='col-xs-12 col-sm-12' *ngIf="validarDenuncia.value">
          <p>
            <small style="font-size: 0.62rem;">* {{ 'texto_868' | translate }}: {{nameComplianceFinal}}</small><br>
          </p>
          <p *ngIf="flag1 && compliancesDeclined.length === 1">
            <small style="font-size: 0.62rem;">
              * {{ 'texto_881' | translate }}: {{ compliancesDeclined[0] }}
            </small><br>
          </p>

          <p *ngIf="flag1 && compliancesDeclined.length > 1">
            <small style="font-size: 0.62rem;">
              * {{ 'texto_882' | translate }}: {{ compliancesDeclined.join(', ') }}
            </small><br>
          </p>
        </div>
        <div class="text-center mt-3">
          <button (click)="validar()" [disabled]="!nameComplianceFinal" style="color:#fff" mdbBtn rounded="true"
            class="btn-primary mt-1 waves-light" mdbWavesEffect>{{ 'texto_114' | translate }}
          </button>
        </div>

      </div>
      <!--/.Content-->
    </div>
  </div>
</div>
